export const chartButtons = "chart-buttons d-flex flex-column";
export const button = "mb-4 text-white";
export const variant = "outline-info";
